export default __webpack_public_path__ + "static/media/oasity_logo.9d38b4f7.png";